import { FC } from 'react'

export const Marketplace: FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Marketplace</h1>
        <p className="mt-1 text-sm text-gray-400">
          API simulator and marketplace tools.
        </p>
      </div>
      
      <div className="bg-[#182233] shadow rounded-lg p-6">
        <p className="text-gray-400">Marketplace page content coming soon...</p>
      </div>
    </div>
  )
}
